import { AssetCatalog, ConfigEditor } from "src/Modules";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Arbitrage } from "src/Modules/Arbitrage";
import { PredictionsModule } from "src/Modules/Predictions";
import { Login } from "src/Modules/Login";
import { Layout } from "src/Common";
import { AUTH_DISABLED } from "./Providers";
import { _getToken } from "src/Config/axiosApi";

function getDefaultRoute(): string {
  const storedMode = localStorage.getItem("app_mode");
  if (storedMode === "predictions") return "/predictions/opportunities";
  return "/arbitrage";
}

// Main app routes (used when authenticated or auth disabled)
const AuthenticatedApp = () => (
  <BrowserRouter>
    <Layout>
      <Routes>
        <Route path="arbitrage/*" element={<Arbitrage />} />
        <Route path="predictions/*" element={<PredictionsModule />} />
        <Route path="config-editor/*" element={<ConfigEditor />} />
        <Route path="assets" element={<AssetCatalog />} />
        {/* Redirects from old paths */}
        <Route
          path="prediction-mapper"
          element={<Navigate replace to="/predictions/mapper" />}
        />
        <Route
          path="arbitrage/predictions"
          element={<Navigate replace to="/predictions/opportunities" />}
        />
        <Route
          path="arbitrage/predictions/*"
          element={<Navigate replace to="/predictions/opportunities" />}
        />
        <Route
          path="arbitrage/predictions-status"
          element={<Navigate replace to="/predictions/status" />}
        />
        <Route path="/" element={<Navigate replace to={getDefaultRoute()} />} />
      </Routes>
    </Layout>
  </BrowserRouter>
);

// Main router - skips auth when disabled, otherwise checks for token
export const AppRouter = () => {
  if (AUTH_DISABLED) {
    return <AuthenticatedApp />;
  }

  const token = _getToken();
  return token ? <AuthenticatedApp /> : <Login />;
};
